// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circulation {
  border-radius: 8px;
  background: #ffffff;
}

.circulation__wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 100px;
}

.circulation__tabs {
  padding: 8px 24px 0 24px;
  border-bottom: 1px solid #0000001f;
  display: flex;
  gap: 8px;
  overflow-inline: auto;
  overflow-block: hidden;
}

.circulation__tab {
  position: relative;
  color: #999999;
  padding: 8px 12px;
  font-family: Poppins, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  background: unset;
  border: unset;
  white-space: nowrap;
}

.circulation__tab-active {
  color: #323232;
}

.circulation__tab-active::after {
  position: absolute;
  bottom: -2px;
  left: 0;
  content: '';
  width: 100%;
  height: 3px;
  border-radius: 16px;
  background: red;
}

.circulation__details {
  padding: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 56px;
  border-bottom: 1px solid #0000001f;
}

.circulation__details-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.circulation__details-title {
  color: #999999;
  font-family: Poppins, serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.circulation__details-description {
  color: #323232;
  font-family: Poppins, serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
}

.circulation__details-description--blue {
  color: #24a3ff;
}

.circulation__details-description--red {
  color: #ff0009;
}

.circulation__details-button {
  margin-left: auto;
  padding: 11px 20px;
  border-radius: 8px;
  border: 1px solid #ff0009;
  background: #ffffff;
  color: #ff0009;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all ease 0.3s;
}

.circulation__details-button:hover {
  background: #ff0009;
  color: #ffffff;
}

.circulation__details-blur {
  filter: blur(5px);
}

.circulation__games {
  padding: 24px 0;
  overflow-x: auto;
  height: auto;
}

.circulation__games-header {
  display: grid;
  grid-template-columns: 538px 1fr 1fr 1fr;
  padding-inline: 24px;
}

.circulation__game {
  display: grid;
  padding: 10px 24px;
  grid-template-columns: 538px 1fr 1fr 1fr;
}

.circulation__game-title {
  color: #323232;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin-bottom: 4px;
}

.circulation__game-date {
  color: #323232;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  gap: 16px;
}

.circulation__game:nth-child(2n) {
  background-color: #eaf6ff;
}

.text-red {
  color: #ff0009;
}

.toolbar {
  width: 100%;
  background-color: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 2px -8px 19px -13px rgba(0, 0, 0, 0.12);
}

.toolbar__inner {
  max-width: 1240px;
  height: 100%;
  margin: auto;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
}

.toolbar__quick-selections {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.toolbar__info {
  color: #7e8299;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  display: flex;
  gap: 4px;
}

.toolbar__selection-button {
  position: relative;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #ff0009;
  background: rgba(255, 0, 9, 0.1);
  color: #ff0009;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  transition: all ease 0.3s;
  display: flex;
  align-items: center;
  gap: 4px;
}

.toolbar__selection-button:hover {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
}

.toolbar__selection-button-active {
  background-color: #ff0009;
  color: #ffffff;
  padding-left: 30px;
}

.toolbar__button {
  padding: 16px 28px;
  border-radius: 8px;
  background: #ff0009;
  color: #f6f6f6;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  transition: all ease 0.3s;
}

.toolbar__button:hover {
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
}

.toolbar__button-light {
  color: #ff0009;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  background: #ffffff;
  transition: all ease 0.3s;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 16px 28px;
}

.toolbar__button-light:hover {
  border-color: #ff0009;
}

.mobile-option-name {
  display: none;
}

.animated-check {
  position: absolute;
  left: 10px;
  height: 16px;
  width: 16px;
}

.animated-check path {
  fill: none;
  stroke: #ffffff;
  stroke-width: 4;
  stroke-dasharray: 23;
  stroke-dashoffset: 23;
  animation: draw 0.3s linear forwards;
  stroke-linecap: round;
  stroke-linejoin: round;
}

@keyframes draw {
  to {
    stroke-dashoffset: 0;
  }
}

@media only screen and (max-width: 800px) {
  .circulation__wrapper {
    padding-bottom: unset;
  }
  .circulation__details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .circulation__details-button {
    margin: unset;
    justify-self: start;
  }
  .circulation__games-header {
    display: none;
  }
  .circulation__game {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;
  }
  .circulation__game-text {
    grid-column: 1 / -1;
  }
  .toolbar {
    position: unset;
    background: unset;
    box-shadow: unset;
  }
  .toolbar__inner {
    flex-wrap: wrap;
    gap: 24px;
  }
  .mobile-option-name {
    display: inline;
  }
}

@media only screen and (max-width: 500px) {
  .circulation__details {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .circulation__details-button {
    margin: unset;
    justify-self: start;
  }
  .circulation__games-header {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/home/components/PlayCirculation/PlayCirculation.scss","webpack://./src/modules/home/components/PlayCirculation/PlayCirculation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;ACCrB;;ADCE;EAGE,aAAS;EAIX,sBAAQ;EACN,SAAS;EACT,qBAAe;ACEnB;;AAEA;EDAI,wBAAsB;EACvB,kCAAA;EAGC,aAAU;EACV,QAAO;EACP,qBAAiB;EACjB,sBAAa;ACEjB;;AAEA;EDAI,kBAAiB;EACjB,cAAY;EACZ,iBAAa;EACb,2BAAmB;EAgBpB,eAAA;ECbD,kBAAkB;EDDhB,gBAAA;EACE,iBAAc;EAYf,iBAAA;ECRH,aAAa;EDLV,mBAAA;ACOL;;AAEA;EDFQ,cAAW;ACInB;;AAEA;EDFQ,kBAAe;EAChB,YAAA;ECIL,OAAO;EDAP,WAAA;EACE,WAAS;EACT,WAAS;EACT,mBAAe;EACf,eAAS;ACEb;;AAEA;EDDI,aAAA;EAGE,aAAQ;ECIR,eAAe;EDDjB,SAAA;EACE,kCAAc;ACGpB;;AAEA;EDCK,aAAA;EAIC,sBAA2B;EAC3B,QAAA;ACGN;;AAEA;EDOK,cAAA;ECLH,2BAA2B;EDFvB,eAAA;EACE,kBAAc;EACf,gBAAA;ECIL,iBAAiB;ADFb;;ACKN;EACE,cAAc;EDDZ,2BAAS;EACP,eAAa;EACb,kBAAkB;EAClB,gBAAe;EACf,iBAAQ;ACGd;;AAEA;EDDM,cAAY;ACGlB;;AAEA;EDIK,cAAA;ACFL;;AAEA;EDFQ,iBAAc;EACf,kBAAA;ECIL,kBAAkB;EDDhB,yBAAO;EACL,mBAAiB;EAClB,cAAA;ECGH,eAAe;EDAf,kBAAS;EACP,gBAAe;EAEf,mBAAgB;EAQjB,yBAAA;ACLH;;AAEA;EDAM,mBAAA;EACA,cAAc;ACEpB;;ADEE;EAES,iBAAW;ACCtB;;AAEA;EDAI,eAAA;EACE,gBAAc;EACd,YAAW;ACEjB;;AAEA;EDCK,aAAA;EAED,wCAAO;EACL,oBAAc;ACEpB;;AAEA;EDCM,aAAa;EACb,kBAAS;ECGT,wCAAwC;ADxB3C;;AC2BH;EACE,cAAc;EDEhB,eAAU;EACR,kBAAc;EACf,gBAAA;ECAC,iBAAiB;EDEnB,kBAAS;ACAT;;AAEA;EDEE,cAAS;EACT,eAAO;EACP,kBAAiB;EAwFlB,gBAAA;ECvFC,iBAAiB;EDGf,aAAY;EACZ,SAAQ;ACCZ;;AAEA;EDCG,yBAAA;ACCH;;AAEA;EDCI,cAAc;ACClB;;AAEA;EDCE,WAAA;EACE,yBAAc;EACd,eAAe;EACf,SAAA;EACA,OAAA;EAEO,mDAAM;ACCjB;;AAEA;EDCE,iBAAA;EACE,YAAU;EACV,YAAS;EACT,kBAAkB;EAGlB,aAAO;EAGP,8BAAgB;ACCpB;;AAEA;EDaG,aAAA;EAPE,sBAAA;ECEH,QAAQ;ADAN;;ACGJ;EDAM,cAAc;EACf,eAAA;ECEH,kBAAkB;EDClB,gBAAU;EACR,iBAAS;EAGT,aAAO;EACP,QAAA;ACCJ;;AAEA;EDCI,kBAAiB;EACjB,iBAAY;EAuBb,kBAAA;ECrBD,yBAAyB;EDZxB,gCAYS;EACN,cAAc;EACf,eAAA;ECEH,kBAAkB;EDAhB,gBAAA;EACE,iBAAc;EAEd,yBAAe;EAGf,aAAa;EAGL,mBAAA;EACR,QAAA;ACEN;;AAEA;EDAQ,yCAAqB;ACG7B;;ADGA;EACE,yBAAa;EACd,cAAA;ECAC,kBAAkB;ADEpB;;ACCA;EDEE,kBAAY;EACZ,kBAAW;EACZ,mBAAA;ECAC,cAAc;EDEhB,kBAAoB;EAClB,eAAU;EACV,kBAAe;EACf,gBAAe;EACf,iBAAgB;EAEhB,yBAAW;ACAb;;AAEA;EDGU,yCAAA;ACAV;;AAEA;EACE,cAAc;EACd,kBAAkB;EDEpB,eAAY;EAER,kBAAA;ECDF,gBDEkB;ECDlB,iBDEG;EACD,mBAAA;ECAF,yBDE2B;ECD3B,6BDEa;ECDb,kBDOG;EAJC,kBAAA;ACDN;;AAEA;EDMM,qBAAA;ACJN;;AAEA;EACE,aDOI;ACNN;;AAEA;EACE,kBDMmB;ECLnB,UDMK;EAIL,YAAS;ECRT,WDSU;ACRZ;;AAEA;EDUI,UAAA;ECRF,eDSe;ECRf,eDSa;ECRb,oBDSG;EAGH,qBAAoB;EAEnB,oCAAA;ECVD,qBAAqB;EACrB,sBAAsB;ADYxB;;ACHA;EDgBM;IACE,oBAAa;ECdnB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IAEE,aAAa;IAET,8BAA8B;IAClC,SAAS;EACX;EACA;IACE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,aAAa;EACf;EACA;IAEM,kCAAkC;IACtC,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IAET,iBAAiB;EAC3B;EACA;IAEM,eAAe;IACnB,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IAEE,aAAa;IAET,8BAA8B;EACpC;EACA;IACE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".circulation {\n  border-radius: 8px;\n  background: #ffffff;\n\n  &__wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    padding-bottom: 100px;\n  }\n\n  &__tabs {\n    padding: 8px 24px 0 24px;\n    border-bottom: 1px solid #0000001f;\n    display: flex;\n    gap: 8px;\n    overflow-inline: auto;\n    overflow-block: hidden;\n  }\n\n  &__tab {\n    position: relative;\n    color: #999999;\n    padding: 8px 12px;\n    font-family: Poppins, serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 22px;\n    background: unset;\n    border: unset;\n    white-space: nowrap;\n\n    &-active {\n      color: #323232;\n\n      &::after {\n        position: absolute;\n        bottom: -2px;\n        left: 0;\n        content: '';\n        width: 100%;\n        height: 3px;\n        border-radius: 16px;\n        background: red;\n      }\n    }\n  }\n\n  &__details {\n    padding: 24px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 56px;\n    border-bottom: 1px solid #0000001f;\n\n    &-item {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n    }\n\n    &-title {\n      color: #999999;\n      font-family: Poppins, serif;\n      font-size: 12px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 18px;\n    }\n\n    &-description {\n      color: #323232;\n      font-family: Poppins, serif;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 21px;\n\n      &--blue {\n        color: #24a3ff;\n      }\n\n      &--red {\n        color: #ff0009;\n      }\n    }\n\n    &-button {\n      margin-left: auto;\n      padding: 11px 20px;\n      border-radius: 8px;\n      border: 1px solid #ff0009;\n      background: #ffffff;\n      color: #ff0009;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n      transition: all ease 0.3s;\n\n      &:hover {\n        background: #ff0009;\n        color: #ffffff;\n      }\n    }\n\n    &-blur {\n      filter: blur(5px);\n    }\n  }\n\n  &__games {\n    padding: 24px 0;\n    // height: 500px;\n    overflow-x: auto;\n    height: auto;\n\n    &-header {\n      display: grid;\n      grid-template-columns: 538px 1fr 1fr 1fr;\n      padding-inline: 24px;\n    }\n  }\n\n  &__game {\n    display: grid;\n    padding: 10px 24px;\n    grid-template-columns: 538px 1fr 1fr 1fr;\n\n    &-title {\n      color: #323232;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 16px;\n      margin-bottom: 4px;\n    }\n\n    &-date {\n      color: #323232;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 16px;\n      display: flex;\n      gap: 16px;\n    }\n\n    &:nth-child(2n) {\n      background-color: #eaf6ff;\n    }\n  }\n}\n\n.text-red {\n  color: #ff0009;\n}\n\n.toolbar {\n  width: 100%;\n  background-color: #ffffff;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  box-shadow: 2px -8px 19px -13px rgba(0, 0, 0, 0.12);\n\n  &__inner {\n    max-width: 1240px;\n    height: 100%;\n    margin: auto;\n    padding: 12px 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &__quick-selections {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__info {\n    color: #7e8299;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    display: flex;\n    gap: 4px;\n  }\n\n  &__selection-button {\n    position: relative;\n    padding: 6px 12px;\n    border-radius: 8px;\n    border: 1px solid #ff0009;\n    background: rgba(255, 0, 9, 0.1);\n    color: #ff0009;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 22px;\n    transition: all ease 0.3s;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n\n    &:hover {\n      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n    }\n\n    &-active {\n      background-color: #ff0009;\n      color: #ffffff;\n      padding-left: 30px;\n    }\n  }\n\n  &__button {\n    padding: 16px 28px;\n    border-radius: 8px;\n    background: #ff0009;\n    color: #f6f6f6;\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 20px;\n    transition: all ease 0.3s;\n\n    &:hover {\n      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n    }\n\n    &-light {\n      color: #ff0009;\n      text-align: center;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 20px;\n      background: #ffffff;\n      transition: all ease 0.3s;\n      border: 1px solid transparent;\n      border-radius: 8px;\n      padding: 16px 28px;\n\n      &:hover {\n        border-color: #ff0009;\n      }\n    }\n  }\n}\n\n.mobile-option-name {\n  display: none;\n}\n\n.animated-check {\n  position: absolute;\n  left: 10px;\n  height: 16px;\n  width: 16px;\n}\n\n.animated-check path {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 4;\n  stroke-dasharray: 23;\n  stroke-dashoffset: 23;\n  animation: draw 0.3s linear forwards;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n@keyframes draw {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .circulation {\n    &__wrapper {\n      padding-bottom: unset;\n    }\n    &__details {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n\n      &-button {\n        margin: unset;\n        justify-self: start;\n      }\n    }\n\n    &__games {\n      &-header {\n        display: none;\n      }\n    }\n\n    &__game {\n      grid-template-columns: 1fr 1fr 1fr;\n      gap: 16px;\n      &-text {\n        grid-column: 1 / -1;\n      }\n    }\n  }\n\n  .toolbar {\n    position: unset;\n    background: unset;\n    box-shadow: unset;\n\n    &__inner {\n      flex-wrap: wrap;\n      gap: 24px;\n    }\n  }\n\n  .mobile-option-name {\n    display: inline;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  .circulation {\n    &__details {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n\n      &-button {\n        margin: unset;\n        justify-self: start;\n      }\n    }\n\n    &__games {\n      &-header {\n        display: none;\n      }\n    }\n  }\n}\n",".circulation {\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.circulation__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 20px;\n  padding-bottom: 100px;\n}\n\n.circulation__tabs {\n  padding: 8px 24px 0 24px;\n  border-bottom: 1px solid #0000001f;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 8px;\n  overflow-inline: auto;\n  overflow-block: hidden;\n}\n\n.circulation__tab {\n  position: relative;\n  color: #999999;\n  padding: 8px 12px;\n  font-family: Poppins, serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  background: unset;\n  border: unset;\n  white-space: nowrap;\n}\n\n.circulation__tab-active {\n  color: #323232;\n}\n\n.circulation__tab-active::after {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  content: '';\n  width: 100%;\n  height: 3px;\n  border-radius: 16px;\n  background: red;\n}\n\n.circulation__details {\n  padding: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 56px;\n  border-bottom: 1px solid #0000001f;\n}\n\n.circulation__details-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 2px;\n}\n\n.circulation__details-title {\n  color: #999999;\n  font-family: Poppins, serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.circulation__details-description {\n  color: #323232;\n  font-family: Poppins, serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 21px;\n}\n\n.circulation__details-description--blue {\n  color: #24a3ff;\n}\n\n.circulation__details-description--red {\n  color: #ff0009;\n}\n\n.circulation__details-button {\n  margin-left: auto;\n  padding: 11px 20px;\n  border-radius: 8px;\n  border: 1px solid #ff0009;\n  background: #ffffff;\n  color: #ff0009;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  -webkit-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n}\n\n.circulation__details-button:hover {\n  background: #ff0009;\n  color: #ffffff;\n}\n\n.circulation__details-blur {\n  -webkit-filter: blur(5px);\n          filter: blur(5px);\n}\n\n.circulation__games {\n  padding: 24px 0;\n  overflow-x: auto;\n  height: auto;\n}\n\n.circulation__games-header {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 538px 1fr 1fr 1fr;\n      grid-template-columns: 538px 1fr 1fr 1fr;\n  padding-inline: 24px;\n}\n\n.circulation__game {\n  display: -ms-grid;\n  display: grid;\n  padding: 10px 24px;\n  -ms-grid-columns: 538px 1fr 1fr 1fr;\n      grid-template-columns: 538px 1fr 1fr 1fr;\n}\n\n.circulation__game-title {\n  color: #323232;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 16px;\n  margin-bottom: 4px;\n}\n\n.circulation__game-date {\n  color: #323232;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 16px;\n}\n\n.circulation__game:nth-child(2n) {\n  background-color: #eaf6ff;\n}\n\n.text-red {\n  color: #ff0009;\n}\n\n.toolbar {\n  width: 100%;\n  background-color: #ffffff;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  -webkit-box-shadow: 2px -8px 19px -13px rgba(0, 0, 0, 0.12);\n          box-shadow: 2px -8px 19px -13px rgba(0, 0, 0, 0.12);\n}\n\n.toolbar__inner {\n  max-width: 1240px;\n  height: 100%;\n  margin: auto;\n  padding: 12px 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.toolbar__quick-selections {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  gap: 4px;\n}\n\n.toolbar__info {\n  color: #7e8299;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 4px;\n}\n\n.toolbar__selection-button {\n  position: relative;\n  padding: 6px 12px;\n  border-radius: 8px;\n  border: 1px solid #ff0009;\n  background: rgba(255, 0, 9, 0.1);\n  color: #ff0009;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  -webkit-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 4px;\n}\n\n.toolbar__selection-button:hover {\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n}\n\n.toolbar__selection-button-active {\n  background-color: #ff0009;\n  color: #ffffff;\n  padding-left: 30px;\n}\n\n.toolbar__button {\n  padding: 16px 28px;\n  border-radius: 8px;\n  background: #ff0009;\n  color: #f6f6f6;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  -webkit-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n}\n\n.toolbar__button:hover {\n  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n}\n\n.toolbar__button-light {\n  color: #ff0009;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  background: #ffffff;\n  -webkit-transition: all ease 0.3s;\n  transition: all ease 0.3s;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  padding: 16px 28px;\n}\n\n.toolbar__button-light:hover {\n  border-color: #ff0009;\n}\n\n.mobile-option-name {\n  display: none;\n}\n\n.animated-check {\n  position: absolute;\n  left: 10px;\n  height: 16px;\n  width: 16px;\n}\n\n.animated-check path {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 4;\n  stroke-dasharray: 23;\n  stroke-dashoffset: 23;\n  -webkit-animation: draw 0.3s linear forwards;\n          animation: draw 0.3s linear forwards;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n@-webkit-keyframes draw {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes draw {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@media only screen and (max-width: 800px) {\n  .circulation__wrapper {\n    padding-bottom: unset;\n  }\n  .circulation__details {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n    gap: 16px;\n  }\n  .circulation__details-button {\n    margin: unset;\n    -ms-grid-column-align: start;\n        justify-self: start;\n  }\n  .circulation__games-header {\n    display: none;\n  }\n  .circulation__game {\n    -ms-grid-columns: 1fr 1fr 1fr;\n        grid-template-columns: 1fr 1fr 1fr;\n    gap: 16px;\n  }\n  .circulation__game-text {\n    grid-column: 1 / -1;\n  }\n  .toolbar {\n    position: unset;\n    background: unset;\n    -webkit-box-shadow: unset;\n            box-shadow: unset;\n  }\n  .toolbar__inner {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    gap: 24px;\n  }\n  .mobile-option-name {\n    display: inline;\n  }\n}\n\n@media only screen and (max-width: 500px) {\n  .circulation__details {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: 1fr 1fr;\n        grid-template-columns: 1fr 1fr;\n  }\n  .circulation__details-button {\n    margin: unset;\n    -ms-grid-column-align: start;\n        justify-self: start;\n  }\n  .circulation__games-header {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
